// material
import { Box, Card, Container, Link, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from '../common/LocalizationProvider';

import { MHidden } from '../components/@material-extend';
import { LoginForm } from '../components/authentication/login';
// components
import Page from '../components/Page';
// layouts
import AuthLayout from '../layouts/AuthLayout';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2, 0, 2, 2),
  backgroundColor: theme.palette.primary.main
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  const t = useTranslation();

  return (
    <RootStyle title={t('login_Title')}>
      <AuthLayout>
        {t('login_FirstConnection')} &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/register">
          {t('login_GetStarted')}
        </Link>
      </AuthLayout>
      <MHidden width="mdDown">
        <SectionStyle>
          <img src="/static/logo.svg" alt="CTO logo" width={160} />
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }} color="white" textAlign="center">
            {t('login_Quote')}
          </Typography>
          <Typography variant="subtitle1" color="white">
            {t('login_Quote_Author')}
          </Typography>
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              {t('login_SignIn')}
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}> {t('login_Details')}</Typography>
          </Stack>

          <Box>
            <LoginForm />
          </Box>

          <MHidden width="smUp">
            <Typography variant="subtitle2" sx={{ mt: 3 }}>
              {t('login_FirstConnection')} &nbsp;
              <Link to="/register" component={RouterLink}>
                {t('login_GetStarted')}
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
